// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'freeze-column';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9 1.031v5.313m2.656-4.25L9 4.219 6.344 2.094M2.099 5.016l4.6 2.656M4.347 3.246l.512 3.363-3.168 1.239m.408 5.136 4.6-2.656m-5.009-.176 3.169 1.239-.512 3.363M9 16.969v-5.313m-2.656 4.25L9 13.781l2.656 2.125m4.245-2.922-4.6-2.656m2.352 4.426-.512-3.363 3.168-1.239m-.408-5.136-4.6 2.656m5.009.176-3.17-1.239.513-3.363M9 6.344 6.7 7.672v2.656L9 11.656l2.3-1.328V7.672z'
  />
);

export const viewBox = '0 0 18 18';
